import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FontLicenseType } from 'client/graphql/types/operations';

import * as Core from 'components/core';
import formatCurrency from 'utils/formatCurrency';
import useCart from './purchaseTable/utils/useCart';

interface Props {
  licenseOption: {
    id: number;
    type: FontLicenseType;
    multiplier: number;
  } | null;
  family: {
    id: number;
    completePrice: number;
    subPackageFontFacePrice: number;
    faces: { id: number }[];
  };
  faces: {
    id: number;
    width: { slug: string; name: string; position: number };
    size: { slug: string; name: string; position: number };
    weight: { slug: string; name: string; position: number };
    family: { fontFacePrice: number; discountedFontFacePrice: number };
  }[];
  unavailable?: boolean;
}

const AddToCartButton: FC<Props> = (props) => {
  const { licenseOption, family, faces, unavailable } = props;

  const { t } = useTranslation();

  const { allFacesInOrder, totalPrice, addFaces, removeFaces, loading } =
    useCart({ licenseOption, family, faces });

  if (licenseOption == null) {
    return null;
  }

  if (unavailable) {
    return (
      <Core.Button inline disabled>
        {t('checkoutCart.unavailable')}
      </Core.Button>
    );
  }

  if (loading) {
    return (
      <Core.Button inline disabled>
        {t('checkoutCart.updating')}
      </Core.Button>
    );
  }

  if (!allFacesInOrder) {
    return (
      <Core.Button
        inline
        onClick={() => {
          addFaces();
        }}
      >
        + {formatCurrency(totalPrice)}
      </Core.Button>
    );
  } else {
    return (
      <Core.Button
        inline
        secondary
        onClick={() => {
          removeFaces();
        }}
      >
        &times; {t('checkoutCart.remove')}
      </Core.Button>
    );
  }
};

export default AddToCartButton;
